/**
 * Breadcrumbs — trilha de navegação (LDS) indicando a localização do usuário.
 *
 * Requisitos: 14.5
 */

import { Fragment } from 'react';
import { LdsTypography } from '@lds/react';
import styles from './Breadcrumbs.module.scss';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

export interface BreadcrumbsProps {
  /** Itens ordenados (o último é o atual, sem link). */
  items: BreadcrumbItem[];
  /** Handler de navegação dos links. */
  onNavigate?: (path: string) => void;
}

export function Breadcrumbs({ items, onNavigate }: BreadcrumbsProps) {
  return (
    <nav aria-label="breadcrumb" className={styles.breadcrumbs}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={item.label}>
            {isLast || !item.path ? (
              <LdsTypography variant="bodySm">
                {item.label}
              </LdsTypography>
            ) : (
              <button
                type="button"
                className={styles.link}
                onClick={() => onNavigate?.(item.path!)}
              >
                <LdsTypography variant="bodySm" color="primary">
                  {item.label}
                </LdsTypography>
              </button>
            )}
            {!isLast && <span className={styles.separator} aria-hidden="true">/</span>}
          </Fragment>
        );
      })}
    </nav>
  );
}
